export default __webpack_public_path__ + "static/media/NotificationCross.047baeea.svg";